// The newest committed Phoebe answer pins its actions once Phoebe is idle or
// waiting on the user. While Phoebe is still working on that answer's turn,
// the actions stay fully hidden so interim lines never offer rating or copy.
import { createContext, useContext } from 'react';

export type LatestAssistantAnswer = Readonly<{
    readonly occurrenceId: string;
    readonly inProgress: boolean;
}>;

export type AssistantActionsVisibility = 'pinned' | 'hidden' | 'hover';

export const LatestAssistantOccurrenceContext =
    createContext<LatestAssistantAnswer | null>(null);

export function useAssistantActionsVisibility(
    occurrenceId: string,
): AssistantActionsVisibility {
    const latest = useContext(LatestAssistantOccurrenceContext);
    if (latest?.occurrenceId !== occurrenceId) {
        return 'hover';
    }
    return latest.inProgress ? 'hidden' : 'pinned';
}
